module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/green/banner_check_icon-5280607608a40cb5079cd49bcbf38cd0.svg";